import {memoize} from '@servicenow/ui-internal';
import {NOW_METRIC_TYPES_PROP, NOW_METRICS_LEVEL_PROP, NOW_LOGGING_LEVELS_PROP} from '../constants';

const skipRenderPropsList = [
	NOW_METRIC_TYPES_PROP,
	NOW_METRICS_LEVEL_PROP,
	NOW_LOGGING_LEVELS_PROP
];

export const isPropToSkipRender = memoize(
	(_tagName, propName, propDef) =>
		skipRenderPropsList.includes(propName) || propDef?.shouldRenderWhenSet === false,
	{
		createCacheKey: (tagName, propName) => `${tagName}|${propName}`,
		profileName: `isPropToSkipRender`
	}
);
